import React, { useEffect, useState } from "react";
//import "./productstable.css";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPencil,
  faTrash,
  faEye,
} from "@fortawesome/free-solid-svg-icons";
import Pagination from "../../common/Pagination";
import { useDispatch, useSelector } from "react-redux";


import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Button from "@mui/material/Button";
import ApprovalTwoToneIcon from '@mui/icons-material/ApprovalTwoTone';
import BlockTwoToneIcon from '@mui/icons-material/BlockTwoTone';
import TimerTwoToneIcon from '@mui/icons-material/TimerTwoTone';
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import { useLocation } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';
import AddCircleOutlineTwoToneIcon from '@mui/icons-material/AddCircleOutlineTwoTone';

import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, MenuItem, TextField, ThemeProvider, createTheme } from "@mui/material";
import { DataGrid, GridApi, GridColDef, GridValueGetterParams, GridCellParams, GridArrowDownwardIcon, GridToolbarContainer, GridToolbarExport } from '@mui/x-data-grid';
import { DownloadProductTableDataService } from "../../service/download.product.tabledata";

import { BrandsService } from "../../service/brands.service";


function DownloadProductTableData() {

  const downloadProductTableDataSvc = new DownloadProductTableDataService();

  const [brandsData, setbrandsData] = useState<any[]>([]);

  //const [availableStatus, setAvailableStatus] = useState<OrderStatus[]>([]);
  const [selectedBrandId, setSelectedBrandId] = React.useState("select");
  const [availableBrands, setAvailableBrands] = useState([]);
  const [productTableData, setProductTableData] = useState<any[]>([]);
  const navigate = useNavigate();


  const [open, setOpen] = React.useState(false);



  const columns: GridColDef[] = [
    { field: 'vcProductCode', headerName: 'vcProductCode', width: 150 },
    { field: 'vcModelNumber', headerName: 'vcModelNumber', flex: 1 },
    { field: 'vcGroupModelNumber', headerName: 'vcGroupModelNumber', flex: 1 },
    { field: 'vcProductDisplayName', headerName: 'vcProductDisplayName', width: 200 },
    { field: 'vcMainCategory', headerName: 'Main Category', flex: 1 },
    { field: 'vcSubCategory', headerName: 'Sub Category', flex: 1 },
    { field: 'vcBrandName', headerName: 'Brand', flex: 1 },
    { field: 'iStatus', headerName: 'iStatus', width: 75 },
    { field: 'vcDisplayImage', headerName: 'vcDisplayImage', flex: 1 },
    { field: 'vcCadDrawing', headerName: 'vcCadDrawing', flex: 1 },
    { field: 'vcReferenceImage', headerName: 'vcReferenceImage', flex: 1 },
    { field: 'vcVideoUrl', headerName: 'vcVideoUrl', flex: 1 },
    { field: 'vcSize', headerName: 'vcSize', width: 100},
    { field: 'vcFinish', headerName: 'vcFinish', width: 75},
    { field: 'vcFeatureList', headerName: 'vcFeatureList', flex: 1 },
    { field: 'dMRP', headerName: 'dMRP', width: 75 },
    { field: 'vcNew', headerName: 'vcNew', width: 25 },
    { field: 'vcRemark', headerName: 'vcRemark', flex: 1 },
    { field: 'dtCreatedDate', headerName: 'dtCreatedDate', flex: 1 },
    { field: 'dtUpdatedDate', headerName: 'dtUpdatedDate', flex: 1 }



  ];
  //useEffect(() => {
  const submitRequest = (checkApprovalStatus: number) => {

  }//, [selectedEnterprise, selectedStatus]);
  const brandsService = new BrandsService();
  const loadbrandsData = () => {
    brandsService.brands(1).then(data => {
      const res = data.data;
      //const { unit, sizes } = res.data;
      console.log("^^^^^^^^^^^^^^Unit " + res.length);
      // const unitGroups: any = [];
      /*  for (let index = 0; index < res.length; index++) {
          const unitG = res[index].unit;
          const sizesG = res[index].sizes;
          unitGroups.push({ ...sizesG, unit: unitG, });
        }*/
      console.log("grpp ", res);
      setAvailableBrands(res);

    });

  }

  const loadProductTableData = () => {

    downloadProductTableDataSvc.getProductsTableData(selectedBrandId).then(data => {
        const res = data.data;
        //console.log('finishesData', res)
        let cnt1 = 0;
        const peopleWithImages = res.map((person: any, index: any) => {
            cnt1 = cnt1 + 1;
            return {
                ...person,
                id:cnt1,
                
               
            };

        });
        setProductTableData(peopleWithImages)


    });

}


  useEffect(() => {

    console.log("eeee " + selectedBrandId)

    if (selectedBrandId == "select") {
        return;
    }
    loadProductTableData();



}, [selectedBrandId])


  let isLoadDataInit = false;
  useEffect(() => {

    if (!isLoadDataInit) {
      isLoadDataInit = true;
      loadbrandsData();
    }

  }, [])

  function CustomToolbar() {
    return (
      <GridToolbarContainer    >
        <GridToolbarExport />
      </GridToolbarContainer>
    );
  }

  const CustomFontTheme = createTheme({
    typography: {
      fontSize: 14
    }
  });

  return (
    <div className="App border card">
      <div className="col-md-12  row">
        <div className=" mb-3 col-2  mt-3 text-left ">
          <ThemeProvider theme={CustomFontTheme}>
            <TextField select size="small" label="Brand Name" id="outlined-start-adornment" InputLabelProps={{ shrink: true }} InputProps={{ sx: { height: 35 } }}
              className="form-control" name='brandId' defaultValue="select" value={selectedBrandId}
              onChange={(e: any) => {
                setSelectedBrandId(e.target.value);

              }}
            >
              <MenuItem style={{ fontSize: "small" }} disabled value="select" key="select">Select</MenuItem>
              <MenuItem style={{ fontSize: "small" }} value={0} key="all">All</MenuItem>
              {availableBrands.map((_el: any) => <MenuItem style={{ fontSize: "small" }} key={_el.brandId} value={_el.brandId}> {_el.brandName}</MenuItem>)}
            </TextField>
          </ThemeProvider>
        </div>

      </div>
      {
        <div style={{ width: '100%' }}>
          <DataGrid
            slots={{
              toolbar: CustomToolbar,
            }}
            // table customization start
            sx={{
              '& .MuiDataGrid-columnHeaderTitle': {
                whiteSpace: "break-spaces", lineHeight: 1, fontSize: "12px", fontWeight: "bold",
              },
              '& .MuiDataGrid-columnHeader': {
                backgroundColor: "#D0D0D0"
              },
              '& .Mui-odd': {
                textOverflow: "inherit", fontSize: "12px", textAlign: "left"
              },

              '& .Mui-even': {
                backgroundColor: "#F7f7f7", textOverflow: "inherit", fontSize: "12px", textAlign: "left"

              },

              '& .Mui-cellown': {
                paddingTop: 0, paddingBottom: 0

              },

            }}

            getCellClassName={(params) => 'Mui-cellown'}
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0 ? 'Mui-even' : 'Mui-odd'}
            autoHeight={true}
            getRowHeight={() => 30}

            // table customization


            rows={productTableData}
            columns={columns}
            initialState={{
              pagination: {
                paginationModel: { page: 0, pageSize: 25 },
              },
            }}
            pageSizeOptions={[25, 50, 100]}

          />
        </div>
      }
    </div>

  );
}


export default DownloadProductTableData;
